import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface OfflineMessageEmailLinkProps {
  email: string;
  color: string;
}

const EmailLinkComponent: React.FC<OfflineMessageEmailLinkProps> = ({
  email,
  color,
}) => {
  return (
    <a href={`mailto:${email}`} style={{ color }} className="email-link">
      {email}
    </a>
  );
};

export const EmailLink: React.FC<OfflineMessageEmailLinkProps> = (
  props: OfflineMessageEmailLinkProps
) => {
  const Component = useCustomComponent({
    componentName: 'OfflineMessageEmailLink',
    Component: EmailLinkComponent,
  });

  return <Component {...props} />;
};
